import { lazy } from "react";

//Lazy workflows
const LazyManageOrderFailureCodes = lazy(
  () => import("./components/workflow/ManageOrderFailureCodes")
);
const LazyManageOrderOperations = lazy(() => import("./components/workflow/ManageOrderOperations"));
const LazyManageConfigurations = lazy(() => import("./components/workflow/ManageConfigurations"));
const LazyManageConsolidatedActions = lazy(
  () => import("./components/workflow/ConsolidatedActions")
);
const LazyManagePaymentsGateway = lazy(() => import("./components/workflow/ManagePaymentsGateway"));

//Workflows
export {
  LazyManageConfigurations as ManageConfigurations,
  LazyManageConsolidatedActions as ManageConsolidatedActions,
  LazyManageOrderFailureCodes as ManageOrderFailureCodes,
  LazyManageOrderOperations as ManageOrderOperations,
  LazyManagePaymentsGateway as ManagePaymentsGateway,
};

//Lazy Functional
const LazyListPaymentTransfers = lazy(
  () => import("./components/functional/PaymentTransfers/ListPayments/ListPayment")
);
const LazyShowTransferDetails = lazy(
  () => import("./components/functional/PaymentTransfers/ShowTransfers/ViewTransferDetails")
);
const LazyRegenerateInvestorFiles = lazy(
  () =>
    import("./components/functional/OrderOperations/RegenerateFatcaAnnexure/RegenerateInvestorFiles")
);
const LazyListFiles = lazy(() => import("./components/functional/OrderOperations/Files/ListFiles"));
const LazyListAgingOrders = lazy(
  () => import("./components/functional/AgingOrders/ListAgingOrders")
);
const LazyListApiLogs = lazy(
  () => import("./components/functional/ApiLogs/ListApiLogs/ListApiLogs")
);
const LazyViewApiLogDetaills = lazy(
  () => import("./components/functional/ApiLogs/ViewApiLogDetaills/ViewApiLogDetails")
);
const LazyAmcConfigurationService = lazy(
  () => import("./components/functional/FpAccount/AmcConfigurationService")
);
const LazyKYCService = lazy(() => import("./components/functional/FpAccount/KycService"));
const LazyOrderConfigurationService = lazy(
  () => import("./components/functional/FpAccount/OrderConfigurationService")
);
const LazyVerificationService = lazy(
  () => import("./components/functional/FpAccount/VerificationsService")
);
const LazyAdvisoryService = lazy(
  () => import("./components/functional/FpAccount/AdvisoryService/AdvisoryService")
);
const LazyFundSchemesListing = lazy(
  () => import("./components/functional/FpAccount/FundSchemes/ListSchemes/FundSchemesListing")
);
const LazyBITool = lazy(() => import("./components/functional/FpAccount/BITool"));
const LazyFeedConfiguration = lazy(
  () => import("./components/functional/FpAccount/FeedConfiguration")
);
const LazyAddTenant = lazy(
  () => import("./components/functional/TenantManagement/AddTenant/AddTenant")
);

const LazyTenantsListing = lazy(
  () => import("./components/functional/TenantManagement/TenantsListing")
);

const LazyTransactionsListing = lazy(
  () => import("./components/functional/Transactions/TransactionsListing")
);

const LazyInternalUsersManagement = lazy(
  () => import("./components/functional/UserManagement/InternalUsers/ListUsers/UserTable")
);

const LazyManageUser = lazy(
  () => import("./components/functional/UserManagement/ManageUser/ManageUser")
);
const LazyTenantUsersManagement = lazy(
  () => import("./components/functional/UserManagement/TenantUsers/ListUsers/UsersListing")
);

const LazyPincodes = lazy(() => import("./components/functional/MasterData/Pincodes"));

const LazyIFSCCodes = lazy(() => import("./components/functional/MasterData/IFSCCodes"));

const LazyScheduledQueries = lazy(
  () =>
    import("./components/functional/FpAccount/ScheduledQueries/ListScheduledQueries/ListScheduledQueries")
);

const LazyScheduledQueryRun = lazy(
  () =>
    import("./components/functional/FpAccount/ScheduledQueries/ListScheduledQueryRuns/ListScheduledQueriesRuns")
);

const LazyEditNotificationWebhooks = lazy(
  () =>
    import("./components/functional/FpAccount/NotificationWebhooks/Update/UpdateNotificationWebhook")
);

const LazyNotificationWebhooks = lazy(
  () => import("./components/functional/FpAccount/NotificationWebhooks/NotificationWebhooks")
);

const LazyPartnersListing = lazy(() => import("./components/functional/Partners/PartnersListing"));
const LazyPartnerAddition = lazy(() => import("./components/functional/Partners/PartnerAddition"));
const LazyPartnerDetails = lazy(
  () => import("./components/functional/Partners/Details/PartnersDetails")
);
const LazyUpcomingDistributorsListing = lazy(
  () => import("./components/functional/Partners/UpcomingDistributors/UpcomingDistributorsListing")
);

const LazyFpAssist = lazy(() => import("./components/functional/FpAccount/FpAssist/FpAssist"));

const LazyBatchFilesListing = lazy(
  () => import("./components/functional/OrderOperations/BatchFiles/BatchFilesListing")
);

const LazyFeedSubmissionJobsListing = lazy(
  () => import("./components/functional/Feeds/FeedSubmissionJobs/FeedSubmissionJobsListing")
);

const LazyFeedSubmissionsListing = lazy(
  () => import("./components/functional/Feeds/FeedSubmissions/FeedSubmissionsListing")
);

const LazyFolioListing = lazy(() => import("./components/functional/Folios/FolioListing"));
const LazyFolioDetails = lazy(
  () => import("./components/functional/Folios/FolioDetails/FolioDetails")
);

const LazySchemeDetails = lazy(
  () => import("./components/functional/FpAccount/FundSchemes/SchemeDetails/SchemeDetails")
);

const LazyEventsListing = lazy(() => import("./components/functional/Events/EventsListing"));
const LazyMonitoringAlertsListing = lazy(
  () => import("./components/functional/MonitoringAlerts/MonitoringAlertsListing")
);

const LazyPurchaseListing = lazy(
  () => import("./components/functional/Orders/Purchases/PurchaseListing/PurchaseListing")
);
const LazyPurchaseDetails = lazy(
  () => import("./components/functional/Orders/Purchases/PurchaseDetails/PurchaseDetails")
);
const LazyRedemptionListing = lazy(
  () => import("./components/functional/Orders/Redemptions/RedemptionListing/RedemptionListing")
);
const LazyRedemptionDetails = lazy(
  () => import("./components/functional/Orders/Redemptions/RedemptionDetails/RedemptionDetails")
);
const LazySwitchListing = lazy(
  () => import("./components/functional/Orders/Switches/SwitchListing/SwitchListing")
);
const LazySwitchDetails = lazy(
  () => import("./components/functional/Orders/Switches/SwitchDetails/SwitchDetails")
);
const LazyPurchasePlanListing = lazy(
  () =>
    import("./components/functional/Orders/PurchasePlan/PurchasePlanListing/PurchasePlanListing")
);
const LazyPurchasePlanDetails = lazy(
  () =>
    import("./components/functional/Orders/PurchasePlan/PurchasePlanDetails/PurchasePlanDetails")
);
const LazyRedemptionPlanListing = lazy(
  () =>
    import("./components/functional/Orders/RedemptionPlan/RedemptionPlanListing/RedemptionPlanListing")
);
const LazyRedemptionPlanDetails = lazy(
  () =>
    import("./components/functional/Orders/RedemptionPlan/RedemptionPlanDetails/RedemptionPlanDetails")
);
const LazySwitchPlanListing = lazy(
  () => import("./components/functional/Orders/SwitchPlan/SwitchPlanListing/SwitchPlanListing")
);
const LazySwitchPlanDetails = lazy(
  () => import("./components/functional/Orders/SwitchPlan/SwitchPlanDetails/SwitchPlanDetails")
);

const LazyOrderChartsListing = lazy(
  () => import("./components/functional/Orders/OrderCharts/OrderCharts")
);

const LazyProductUsage = lazy(
  () => import("./components/functional/Orders/ProductUsage/ProductUsage")
);

const LazyOrderInsights = lazy(
  () => import("./components/functional/Metrics/OrderInsights/OrderInsights")
);

const LazyHealthMetrics = lazy(
  () => import("./components/functional/Metrics/HealthMetrics/HealthMetrics")
);

const LazyApiMetrics = lazy(() => import("./components/functional/Metrics/ApiMetrics/ApiMetrics"));

const LazyKycInsights = lazy(
  () => import("./components/functional/Metrics/KycInsights/KycInsights")
);

const LazyPanVerificationsListing = lazy(
  () => import("./components/functional/Verifications/PanVerifications/PanVerificationsListing")
);

const LazyKycStatusChecksListing = lazy(
  () => import("./components/functional/Verifications/KycStatusChecks/KycStatusChecksListing")
);

const LazyBankAccountVerificationsStandaloneListing = lazy(
  () =>
    import("./components/functional/Verifications/BankAccountVerifications/BankAccountVerificationsStandaloneListing")
);

const LazyPaymentListing = lazy(
  () => import("./components/functional/Payments/Payments/PaymentListing")
);
const LazyPaymentDetails = lazy(
  () => import("./components/functional/Payments/Payments/PaymentDetails")
);
const LazyPayoutsListing = lazy(() => import("./components/functional/Payouts/PayoutsListing"));
const LazyOrderFeedsListing = lazy(
  () => import("./components/functional/Payouts/OrderFeeds/OrderFeedsListing")
);
const LazyOrderFeedDetails = lazy(
  () => import("./components/functional/Payouts/OrderFeeds/OrderFeedDetails/OrderFeedDetails")
);
const LazyReconListing = lazy(() => import("./components/functional/Payouts/Recon/ReconListing"));
const LazyReconDetails = lazy(() => import("./components/functional/Payouts/Recon/ReconDetails"));
const LazySettlementInstructionsListing = lazy(
  () =>
    import("./components/functional/Payouts/SettlementInstructions/SettlementInstructionsListing")
);
const LazySettlementReportFilesListing = lazy(
  () => import("./components/functional/Payouts/SettlementReportFiles/SettlementReportFilesListing")
);
const LazySettlementInstructionDetails = lazy(
  () =>
    import("./components/functional/Payouts/SettlementInstructions/SettlementInstructionDetails/SettlementInstructionDetails")
);
const LazyDepositReceiptsListing = lazy(
  () => import("./components/functional/Payouts/DepositReceipts/DepositReceiptsListing")
);
const LazyDepositReceiptAdjustmentsListing = lazy(
  () =>
    import("./components/functional/Payouts/DepositReceiptAdjustments/DepositReceiptAdjustmentsListing")
);
const LazyDepositReceiptAdjustmentDetails = lazy(
  () =>
    import("./components/functional/Payouts/DepositReceiptAdjustments/DepositReceiptAdjustmentDetails/DepositReceiptAdjustmentDetails")
);
const LazyReconAdjustmentsListing = lazy(
  () => import("./components/functional/Payouts/ReconAdjustments/ReconAdjustmentsListing")
);
const LazyReconAdjustmentDetails = lazy(
  () =>
    import("./components/functional/Payouts/ReconAdjustments/ReconAdjustmentDetails/ReconAdjustmentDetails")
);
const LazyDepositReceiptDetails = lazy(
  () =>
    import("./components/functional/Payouts/DepositReceipts/DepositReceiptDetails/DepositReceiptDetails")
);
const LazySettlementDetails = lazy(
  () => import("./components/functional/Payouts/Settlements/SettlementDetails/SettlementDetails")
);
const LazyBankAccountStatementsListing = lazy(
  () => import("./components/functional/Payouts/BankAccountStatements/BankAccountStatementsListing")
);
const LazyBankAccountStatementDetails = lazy(
  () =>
    import("./components/functional/Payouts/BankAccountStatements/BankAccountStatementDetails/BankAccountStatementDetails")
);
const LazyPayoutDetails = lazy(
  () => import("./components/functional/Payouts/PayoutDetails/PayoutDetails")
);

const LazyKYCRequestsListing = lazy(
  () => import("./components/functional/Investors/KYCRequests/KYCRequestListing/KYCRequestsListing")
);

const LazyKycFormsListing = lazy(
  () => import("./components/functional/Investors/KycForms/KycFormsListing")
);

const LazyKycFormDetails = lazy(
  () => import("./components/functional/Investors/KycForms/KycFormDetails/KycFormDetails")
);

const LazyKYCRequestsDetails = lazy(
  () => import("./components/functional/Investors/KYCRequests/KYCRequestDetails/KYCRequestDetails")
);

const LazyInvestmentAccountsListing = lazy(
  () =>
    import("./components/functional/Investors/InvestmentAccounts/InvestmentAccountsListing/InvestmentAccountsListing")
);

const LazyInvestmentAccountsDetails = lazy(
  () =>
    import("./components/functional/Investors/InvestmentAccounts/InvestmentAccountsDetails/InvestmentAccountsDetails")
);

const LazyInvestorsListing = lazy(
  () => import("./components/functional/Investors/InvestorsListing/InvestorsListing")
);

const LazyInvestorProfilesListing = lazy(
  () => import("./components/functional/Investors/InvestorProfilesListing/InvestorProfilesListing")
);

const LazyInvestorProfileDetails = lazy(
  () => import("./components/functional/Investors/InvestorProfileDetails/InvestorProfileDetails")
);

const LazyInvestorDetails = lazy(
  () => import("./components/functional/Investors/InvestorDetails/InvestorDetails")
);

const LazyMandatesListing = lazy(
  () => import("./components/functional/Payments/Mandates/MandatesListing")
);

const LazyMandatesDetails = lazy(
  () => import("./components/functional/Payments/Mandates/MandatesDetail")
);

const LazyBankAccountVerificationsListing = lazy(
  () => import("./components/functional/BankAccountVerifications/BankAccountVerificationsListing")
);

const LazyFeedback = lazy(() => import("./components/functional/Feedback/Feedback"));

const LazyNonIndividualInvestorProfilesListing = lazy(
  () =>
    import("./components/functional/Investors/NonIndividualInvestorProfiles/NonIndividualInvestorProfilesListing")
);
const LazyNonIndividualInvestorProfileDetails = lazy(
  () =>
    import("./components/functional/Investors/NonIndividualInvestorProfiles/NonIndividualInvestorProfileDetails/NonIndividualInvestorProfileDetails")
);

const LazyBankSettings = lazy(
  () => import("./components/functional/FpAccount/BankSettings/BankSettings")
);
const LazyEnableBank = lazy(
  () => import("./components/functional/FpAccount/BankSettings/EnableBank")
);
const LazyUpdateBankSettings = lazy(
  () => import("./components/functional/FpAccount/BankSettings/UpdateBankSettings")
);

const LazySchemeManagement = lazy(
  () => import("./components/functional/MasterData/SchemeManagement/SchemeManagement")
);

const LazyBlockedBankAccounts = lazy(
  () => import("./components/functional/BlockedBankAccounts/BlockedBankAccounts")
);

const LazyManualBankAccountVerificationListing = lazy(
  () =>
    import("./components/functional/ManualBankAccountVerification/ManualBankAccountVerificationListing")
);

const LazyVerifyBankAccount = lazy(
  () => import("./components/functional/ManualBankAccountVerification/VerifyBankAccount")
);

const LazyOndcTransactionsListing = lazy(
  () => import("./components/functional/OrderOperations/OndcTransactions/OndcTransactionsListing")
);

const LazyRequestFeedFile = lazy(
  () => import("./components/functional/OrderOperations/RequestFeedFile")
);

const LazyOndcTransactionsDetails = lazy(
  () =>
    import("./components/functional/OrderOperations/OndcTransactions/OndcTransactionsDetails/OndcTransactionsDetails")
);

const LazySupportIssues = lazy(() => import("./components/functional/Support/SupportIssues"));
const LazyRequireSupportAccess = lazy(
  () => import("./components/functional/Support/RequireSupportAccess")
);
const LazyCreateSupportIssue = lazy(
  () => import("./components/functional/Support/CreateSupportIssue")
);
const LazySupportIssueDetails = lazy(
  () => import("./components/functional/Support/SupportDetails/SupportIssueDetails")
);

//Functional
export {
  LazyAddTenant as AddTenant,
  LazyAdvisoryService as AdvisoryService,
  LazyAmcConfigurationService as AmcConfigurationService,
  LazyFundSchemesListing as FundSchemesListing,
  LazyIFSCCodes as IFSCCodes,
  LazyInternalUsersManagement as InternalUsersManagement,
  LazyKYCService as KYCService,
  LazyListAgingOrders as ListAgingOrders,
  LazyListApiLogs as ListApiLogs,
  LazyListFiles as ListFiles,
  LazyListPaymentTransfers as ListPaymentTransfers,
  LazyManageUser as ManageUser,
  LazyOrderConfigurationService as OrderConfigurationService,
  LazyPincodes as Pincodes,
  LazyRegenerateInvestorFiles as RegenerateInvestorFiles,
  LazyShowTransferDetails as ShowTransferDetails,
  LazyTenantUsersManagement as TenantUsersManagement,
  LazyTenantsListing as TenantsListing,
  LazyTransactionsListing as TransactionsListing,
  LazyVerificationService as VerificationService,
  LazyViewApiLogDetaills as ViewApiLogDetaills,
  LazyBITool as BITool,
  LazyFeedConfiguration as FeedConfiguration,
  LazyScheduledQueries as ScheduledQueries,
  LazyScheduledQueryRun as ScheduledQueryRuns,
  LazyEditNotificationWebhooks as EditNotificationWebhooks,
  LazyNotificationWebhooks as NotificationWebhooks,
  LazyPartnersListing as PartnersListing,
  LazyPartnerAddition as PartnerAddition,
  LazyUpcomingDistributorsListing as UpcomingDistributorsListing,
  LazyFpAssist as FpAssist,
  LazyBatchFilesListing as BatchFilesListing,
  LazyFeedSubmissionJobsListing as FeedSubmissionJobsListing,
  LazyFeedSubmissionsListing as FeedSubmissionsListing,
  LazyFolioListing as FolioListing,
  LazyFolioDetails as FolioDetails,
  LazySchemeDetails as SchemeDetails,
  LazyEventsListing as EventsListing,
  LazyMonitoringAlertsListing as MonitoringAlertsListing,
  LazyPurchaseListing as PurchaseListing,
  LazyPurchaseDetails as PurchaseDetails,
  LazyRedemptionListing as RedemptionListing,
  LazyRedemptionDetails as RedemptionDetails,
  LazySwitchListing as SwitchListing,
  LazySwitchDetails as SwitchDetails,
  LazyPurchasePlanListing as PurchasePlanListing,
  LazyPurchasePlanDetails as PurchasePlanDetails,
  LazyRedemptionPlanListing as RedemptionPlanListing,
  LazyRedemptionPlanDetails as RedemptionPlanDetails,
  LazySwitchPlanListing as SwitchPlanListing,
  LazySwitchPlanDetails as SwitchPlanDetails,
  LazyOrderChartsListing as OrderChartsListing,
  LazyProductUsage as ProductUsage,
  LazyOrderInsights as OrderInsights,
  LazyHealthMetrics as HealthMetrics,
  LazyApiMetrics as ApiMetrics,
  LazyPaymentListing as PaymentListing,
  LazyPaymentDetails as PaymentDetails,
  LazyPayoutsListing as PayoutsListing,
  LazyOrderFeedsListing as OrderFeedsListing,
  LazyOrderFeedDetails as OrderFeedDetails,
  LazyReconListing as ReconListing,
  LazyReconDetails as ReconDetails,
  LazyDepositReceiptsListing as DepositReceiptsListing,
  LazyDepositReceiptAdjustmentsListing as DepositReceiptAdjustmentsListing,
  LazyDepositReceiptAdjustmentDetails as DepositReceiptAdjustmentDetails,
  LazyReconAdjustmentsListing as ReconAdjustmentsListing,
  LazyReconAdjustmentDetails as ReconAdjustmentDetails,
  LazySettlementInstructionsListing as SettlementInstructionsListing,
  LazySettlementInstructionDetails as SettlementInstructionDetails,
  LazySettlementReportFilesListing as SettlementReportFilesListing,
  LazyDepositReceiptDetails as DepositReceiptDetails,
  LazySettlementDetails as SettlementDetails,
  LazyBankAccountStatementsListing as BankAccountStatementsListing,
  LazyBankAccountStatementDetails as BankAccountStatementDetails,
  LazyPayoutDetails as PayoutDetails,
  LazyInvestmentAccountsListing as InvestmentAccountsListing,
  LazyInvestmentAccountsDetails as InvestmentAccountsDetails,
  LazyInvestorsListing as InvestorsListing,
  LazyInvestorProfilesListing as InvestorProfilesListing,
  LazyInvestorProfileDetails as InvestorProfileDetails,
  LazyInvestorDetails as InvestorDetails,
  LazyMandatesListing as MandatesListing,
  LazyMandatesDetails as MandatesDetails,
  LazyPartnerDetails as PartnerDetails,
  LazyBankAccountVerificationsListing as BankAccountVerificationsListing,
  LazyFeedback as Feedback,
  LazyNonIndividualInvestorProfilesListing as NonIndividualInvestorProfilesListing,
  LazyNonIndividualInvestorProfileDetails as NonIndividualInvestorProfileDetails,
  LazyKYCRequestsListing as KYCRequestsListing,
  LazyKycFormsListing as KycFormsListing,
  LazyKycFormDetails as KycFormDetails,
  LazyKYCRequestsDetails as KYCRequestsDetails,
  LazyBankSettings as BankSettings,
  LazyEnableBank as EnableBank,
  LazyUpdateBankSettings as UpdateBankSettings,
  LazySchemeManagement as SchemeManagement,
  LazyBlockedBankAccounts as BlockedBankAccounts,
  LazySupportIssues as SupportIssues,
  LazyRequireSupportAccess as RequireSupportAccess,
  LazyCreateSupportIssue as CreateSupportIssue,
  LazySupportIssueDetails as SupportIssueDetails,
  LazyManualBankAccountVerificationListing as ManualBankAccountVerificationListing,
  LazyVerifyBankAccount as VerifyBankAccount,
  LazyOndcTransactionsListing as OndcTransactionsListing,
  LazyOndcTransactionsDetails as OndcTransactionsDetails,
  LazyRequestFeedFile as RequestFeedFile,
  LazyKycInsights as KycInsights,
  LazyPanVerificationsListing as PanVerificationsListing,
  LazyKycStatusChecksListing as KycStatusChecksListing,
  LazyBankAccountVerificationsStandaloneListing as BankAccountVerificationsStandaloneListing,
};

//Lazy Display
const LazyNotFoundPage = lazy(() => import("./components/display/NotFoundPage"));

//Display
export { LazyNotFoundPage as NotFoundPage };

// HOC
export { default as FpDashboardInit } from "./global/hoc/FpDashboardInit";
